// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=3288-56789
// Component: MessageToDriver
// States: normal | disabled (opacity-38)

import classnames from 'classnames'
import { Icon } from '~/components'
import { useTranslation } from 'react-i18next'

function MessageIcon() {
  return (
    <svg width="24" height="17" viewBox="0 0 24 17" fill="none" aria-hidden="true">
      <path d="M16.5 10C17.3284 10 18 9.32843 18 8.5C18 7.67157 17.3284 7 16.5 7C15.6716 7 15 7.67157 15 8.5C15 9.32843 15.6716 10 16.5 10Z" fill="#17181A"/>
      <path d="M13.5 8.5C13.5 9.32843 12.8284 10 12 10C11.1716 10 10.5 9.32843 10.5 8.5C10.5 7.67157 11.1716 7 12 7C12.8284 7 13.5 7.67157 13.5 8.5Z" fill="#17181A"/>
      <path d="M7.5 10C8.32843 10 9 9.32843 9 8.5C9 7.67157 8.32843 7 7.5 7C6.67157 7 6 7.67157 6 8.5C6 9.32843 6.67157 10 7.5 10Z" fill="#17181A"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17H21.5C22.8807 17 24 15.8807 24 14.5V8.5C24 3.80558 20.1944 0 15.5 0H8.5ZM2 8.5C2 4.91015 4.91015 2 8.5 2H15.5C19.0899 2 22 4.91015 22 8.5V14.5C22 14.7761 21.7761 15 21.5 15H8.5C4.91015 15 2 12.0899 2 8.5Z" fill="#17181A"/>
    </svg>
  )
}

export default function MessageToDriver({ message, onEdit, disabled }) {
  const { t } = useTranslation()

  return (
    <div className={classnames('flex gap-3 items-center py-3 w-full', disabled && 'opacity-[0.38]')}>
      {/* Icon — 44px container, icon centred */}
      <div className="shrink-0 size-11 flex items-center justify-center">
        <MessageIcon />
      </div>

      {/* Text */}
      <div className="flex-1 flex flex-col items-start min-w-0">
        <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface">
          {t('title-message-to-driver')}
        </span>
        {message && (
          <span className="text-[15px] leading-5 text-on-surface-variant">{message}</span>
        )}
      </div>

      {onEdit && !disabled && (
        <button type="button" onClick={onEdit} className="shrink-0 p-2 -mr-2" aria-label={t('title-message-to-driver')}>
          <Icon id="pen" />
        </button>
      )}
    </div>
  )
}
